import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import axios from "../../../Uri";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Avatar, Backdrop, CircularProgress, Dialog, DialogActions, DialogContent, Grid, Stack } from "@mui/material";
import { GetAllBuildings } from "layouts/downloadData/Urls";

function Basic() {
  var userStatus = {};
  var isAuth = { login: false };
  const [rememberMe, setRememberMe] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [modal, setmodal] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [userData, setUserData] = useState({});
  const [data, setData] = useState('');
  const [building, setBuilding] = React.useState([]);
  const [selected, setSelected] = React.useState("");
  const [MyBID, setMyBID] = React.useState("");
  const [bedIdModified, setBedIdModified] = useState(false);

  console.log(MyBID);


  useEffect(() => {
    GetAllBuildings()
      .then((res) => {
        setBuilding(res.data);
        console.log(res.data);

      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong🤦‍♂️");
      });
  }, []);


  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };
  const navigate = useNavigate();
  const initialData = {
    email: "",
    password: "",
    bedId: "",
  };

  const [values, setValues] = useState(initialData);

  const handleInputChangeBedId = (value) => {
    console.log(value);
    let val = value === 1 ? "SN-" : value === 2 ? "VN-" : value === 3 ? 'SKN-' : value === 4 ? "AN-" : "";
    setValues({ ...values, bedId: val });
  };


  const handleInputChange = (e) => {
    // console.log(value);
    const { name, value } = e.target;
    // let val = value === 1 ? "SN-" : value === 2 ? "VN-" : value === 3 ? 'SKN-' : value === 4 ? "AN-" : "";
    // setValues({ ...values, bedId: val });
    setValues({...values,[name]:value})
  };

  const handleModalClose = () => {
    setUserDetails({});
    values.bedId = "";
    setmodal(false)
  }


  useEffect(() => {
    isAuth.login = false;
    sessionStorage.setItem("isLogin", JSON.stringify(isAuth));
    sessionStorage.removeItem("userdata");
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    handleToggle();
    await axios
      .post(
        `/login/getUsersByUserEmailId?email=${values.email}&password=${values.password}`
      )
      .then((res) => {
        userStatus = res.data;
        userData = userStatus.data;
        isAuth.login = true;
        sessionStorage.setItem("isLogin", JSON.stringify(isAuth));
        toast.success("successfully logged in");
      })
      .catch((err) => {
        isAuth.login = false;
        sessionStorage.setItem("isLogin", JSON.stringify(isAuth));
      });
    if (userStatus.status === true) {
      sessionStorage.setItem("userdata", JSON.stringify(userStatus));
      sessionStorage.setItem("userData", JSON.stringify(userData));

      navigate("/tracker");
      toast.success("successfylly logged in ");
    } else if (userData.email !== values.email) {
      handleClose();
      toast.error("Error while Logged😢");
    }
  };

  const verifyUser = async () => {
    const isValidGuestId = /.*/.test(values.bedId);

    console.log(values.bedId);
    setOpen(true);
    if (!isValidGuestId || values.bedId === "") {
      toast.error("Enter valid bedId ");
    } else {
      await axios
        .get(`/guest/tab/${MyBID}/${values.bedId}`)
        .then((res) => {
          const data = res.data;
          console.log(data);
          const updatedUserDetails = {
            id: data.id,
            name: data.guestName,
            bedId: data.bedId,
            image: data.imageUrl
          };

          setUserDetails(updatedUserDetails);
          setOpen(false);
        })
        .catch((err) => {
          console.log(err);
          setUserDetails({});
          toast.error("User not found!");
          setOpen(false);
        });
    }
  }

  const forgotPassword = () => {
    navigate("/forgotPassword");
  };
  const resetPassword = () => {
    navigate("/resetPassword");
  };
  const callAlert = () => {
    alert("Invalid credentials");
  };
  return (
    <BasicLayout image={bgImage}>
      <Dialog
        open={modal}
        onClose={handleModalClose}
        maxWidth="xxl"
      >
        <DialogContent>

          <label value="Select Building: ">Select Building: </label>
          <Select
            sx={{ minHeight: 40 }}
            style={{ width: "50%"}}
            value={selected}
            name="building"
            IconComponent={() => <ArrowDropDownIcon />}
          >
            {building.map((post) => {
              return (
                <MenuItem
                  value={post.buildingName}
                  onClick={async () => {
                    setSelected(post.buildingName);
                    setMyBID(post.buildingId);
                    handleInputChangeBedId(post.buildingId);
                  }}
                >
                  {" "}
                  {post.buildingName}{" "}
                </MenuItem>
              );
            })}
          </Select>
          <MDInput
            style={{ width: "100%",paddingTop :20 }}
            type="bedId"
            name="bedId"
            onChange={(e) => setValues({ ...values, bedId: e.target.value })}
            value={values.bedId}
            label="Bed ID"
          />
          {Object.keys(userDetails).length > 0 &&
            <div>
              <Stack direction="row" spacing={3} paddingTop={4}>
                <Avatar alt={userDetails?.name} src={userDetails.image} style={{ width: 50, height: 50, borderRadius: '50%' }} />
                <h3>{userDetails?.id}</h3>
              </Stack>
              <Stack direction="row" spacing={1} paddingTop={2}>
                <h3>{userDetails?.name}</h3>
                <h3>{userDetails.bedId}</h3>
              </Stack>
            </div>
          }
        </DialogContent>
        <DialogActions>
          <Stack direction={'row'} spacing={2}>
            <MDButton
              width="20%"
              variant="contained"
              color="info"
              size="large"
              justify="center"
              style={{ borderRadius: 10 }}
              onClick={verifyUser}
            >
              VERIFY
            </MDButton>
            <MDButton
              width="20%"
              variant="contained"
              color="info"
              size="large"
              justify="center"
              style={{ borderRadius: 10 }}
              onClick={handleModalClose}
            >
              Close
            </MDButton>
          </Stack>
        </DialogActions>
      </Dialog>
      <MDBox
        mt={1}
        mb={1}
        style={{ position: 'absolute', top: 0, right: 0 }}
      >
        <MDButton onClick={() => setmodal(true)} variant="gradient" color="info">
          <MDTypography
            variant="button"
            color="inherit"
            fontWeight="medium"
            textGradient
          >
            VERIFY USER
          </MDTypography>
        </MDButton>
      </MDBox>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            SRI LAKSHMI HEAVENS
          </MDTypography>
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            SIGN IN
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit}>
            <MDBox mb={2}>
              <MDInput
                style={{ width: "100%" }}
                type="email"
                name="email"
                onChange={handleInputChange}
                value={values.email}
                label="Email"
                fullwidth
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                style={{ width: "100%" }}
                type="password"
                name="password"
                onChange={handleInputChange}
                value={values.password}
                label="Password"
                fullwidth
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton
                //onClick={handleSubmit}
                type="submit"
                variant="gradient"
                color="info"
                fullWidth
              >
                <MDTypography
                  variant="button"
                  color="inherit"
                  fontWeight="medium"
                  textGradient
                >
                  SIGN IN
                </MDTypography>
              </MDButton>
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton
                // onClick={forgotPassword}
                variant="gradient"
                color="info"
                fullWidth
              >
                <MDTypography
                  variant="button"
                  color="inherit"
                  fontWeight="medium"
                  textGradient
                >
                  FORGOT PASSWORD
                </MDTypography>
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
      <ToastContainer
        maxWidth="sx"
        position="top-right"
        autoClose={3000}
        type="toast.TYPE.SUCCESS"
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </BasicLayout >
  );
}
export default Basic;
